import type { CampaignUserStore } from "../../../stores/campaignUser";

const campaignUserStore: CampaignUserStore = {
  campaignUser: {
    campaign_key: "campaign-key",
    metadata: {
      delivery_api: "doordash-drive"
    },
    current_status: "finished",
    identifier: "identifier",
    current_status_updated_at: "1234567890",
    status_reason: null,
    user_key: "user-key",
    channel: "channel"
  },
  hasLoaded: true
};

export default {
  campaignUserStore
};
